import { gql } from "@apollo/client";

export const UPDATE_PROFESIONAL_MONITOREO = gql`
    mutation UpdateProfesionalMonitoreo($input: AddProfesionalMonitoreoInput!) {
        updateProfesionalMonitoreo(profesionalInput: $input) {
            idProfesional
        }
    }
`;

export const adaptProfesionalMonitoreo = (idProfesional, monitoreoFormData) => {
  return {
    idProfesional: idProfesional,
    posgradoEspecifico: monitoreoFormData?.posgradoEspecifico,
    observacionPosgradoEspecifico: monitoreoFormData?.observacionPosgradoEspecifico || '',
    experienciaEspecifica: monitoreoFormData?.experienciaEspecifica,
    observacionExperienciaEspecifica: monitoreoFormData?.observacionExperienciaEspecifica || '',
    profesionalZona: monitoreoFormData?.profesionalZona,
    observacionProfesionalZona: monitoreoFormData?.observacionProfesionalZona || '',
    puntosClasificacion: monitoreoFormData?.puntosClasificacion,
    idCalificacionMonitoreo: monitoreoFormData?.idCalificacionMonitoreo
  };
};